import React from 'react';
import classnames from 'classnames';
import './ConnectAndContribute.scss';

interface ConnectAndContributeProps {
  noMargin?: boolean;
  showContactButton?: boolean;
}

export default function ConnectAndContribute({ noMargin, showContactButton }: ConnectAndContributeProps): React.ReactElement {
  return (
    <div className={classnames('connect', { 'connect__no-margin': noMargin })}>
      <h4>Connect and Contribute</h4>
      <div className="connect__links">
        <div className={classnames('connect__box', { 'connect__box--no-sales': !showContactButton })}>
          <a href="https://projecthub.arduino.cc/" className="connect__link" target="_blank" rel="noreferrer">
            Project Hub
          </a>
          <a href="https://github.com/arduino/docs-content" className="connect__link" target="_blank" rel="noreferrer">
            GitHub Repository
          </a>
          <a href="https://forum.arduino.cc/" className="connect__link" target="_blank" rel="noreferrer">
            Forum
          </a>
        </div>
        <div className={classnames('connect__box', { 'connect__box--no-sales': !showContactButton })}>
          <a href="/certifications/" className="connect__link">
            Product Compliance
          </a>
          <a href="https://support.arduino.cc/" className="connect__link" target="_blank" rel="noreferrer">
            Help Center
          </a>
          {/* Community hided until the time we have a community page. */}
          {/* <a href="https://forum.arduino.cc/" className="connect__links--item" target="_blank" rel="noreferrer">
          Community
        </a> */}
          {/* <a href="https://wiki-content.arduino.cc/en/Guide/Troubleshooting" className="connect__link" target="_blank" rel="noreferrer">
            Troubleshooting
          </a> */}
        </div>
        {showContactButton && (
          <div className="connect__box--sales">
            <p>Interested in growing your business with us?</p>
            <a href="https://www.arduino.cc/pro/contact-us/">Contact Sales</a>
          </div>
        )}
      </div>
    </div>
  );
}
